(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-sticky-preorder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => {
    document.querySelectorAll('[data-home-sticky-preorder]').forEach((sticky) => {
      if (sticky.dataset.visibilityReady) return;
      sticky.dataset.visibilityReady = 'true';
      if (sticky.dataset.stickyMode !== 'after-first') return;
      const main = document.getElementById('MainContent');
      const first = main && Array.from(main.children).find((el) =>
        el.matches('.shopify-section') && el.getBoundingClientRect().height > 0);
      if (!first) return;
      let queued = false;
      const check = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          sticky.classList.toggle('is-visible', first.getBoundingClientRect().bottom <= 0);
        });
      };
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
